import { Locale } from "../../../types";

type IntlLocale =
  | "en-US"
  | "fr-FR"
  | "ko-KR"
  | "ja-JP"
  | "es-ES"
  | "zh-CN"
  | "zh-TW"
  | "de-DE"
  | "it-IT"
  | "sv-SE";

export const localeToIntlLocale: Record<Locale, IntlLocale> = {
  en: "en-US",
  fr: "fr-FR",
  ko: "ko-KR",
  ja: "ja-JP",
  es: "es-ES",
  "zh-CN": "zh-CN",
  "zh-TW": "zh-TW",
  de: "de-DE",
  it: "it-IT",
  sv: "sv-SE",
} as unknown as Record<Locale, IntlLocale>;

/**
 * 숫자를 지정된 로케일 형식에 맞게 포맷팅하는 함수
 *
 * @param number - 포맷팅할 숫자 (number 또는 bigint 타입)
 * @param locale - 포맷팅에 사용할 로케일 (예: 'en-US', 'fr-FR', 'ko-KR')
 * @param minimumFractionDigits - 소수점 이하 자릿수의 최소값 (선택적)
 * @returns 로케일에 맞게 포맷팅된 숫자 문자열
 */
export default function formatNumberToLocale(
  number: number | bigint,
  locale: IntlLocale,
  minimumFractionDigits?: number
) {
  const options = {
    ...(minimumFractionDigits !== undefined ? { minimumFractionDigits } : {}),
  };
  return new Intl.NumberFormat(locale, options).format(number);
}
